// src/app/Auth/components/PrivateRoute.jsx

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { ROUTES } from "../../shared/constants/routes";
import { getUserRole, isAuthenticated } from "../utils/authStorage";
import { getDashboardByRole } from "../utils/roleRedirect";

export default function PrivateRoute({ allowedRoles = [] }) {
  const loggedIn = isAuthenticated();

  if (!loggedIn) {
    return <Navigate to={ROUTES.AUTH_LOGIN} replace />;
  }

  const role = getUserRole();

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to={getDashboardByRole(role)} replace />;
  }

  return <Outlet />;
}